import React from "react";
import "./feature.css";

const Feature = (props) => {
  return (
    <div className="feature">
      <div
        style={
          props.reverse
            ? { flexDirection: "row-reverse", paddingRight: '40px' }
            : { flexDirection: "row" }
        }
        className="feature-wrapper"
      >
        <div
          style={
            props.reverse
              ? { alignItems: "flex-start" }
              : { alignItems: "flex-end" }
          }
          className="feature-wrapper_col"
        >
          <h3 className="feature-name">{props.featureName}</h3>
          <p>{props.children}</p>
        </div>
        <div
          style={
            props.reverse ? { alignItems: "flex-start" } : { alignItems: "auto" }
          }
          className="feature-wrapper_col"
        >
          <img
            style={
              props.reverse
                ? { alignSelf: "flex-start" }
                : { alignItems: "auto" }
            }
            className="feature-thumbnail"
            src={props.thumbnail}
            alt="PL Feature"
          />
        </div>
      </div>
    </div>
  );
};

export default Feature;
